import { api } from 'utility';
import {
  getPermissionUrl,

  getConfirmGrantedPermissonByWalletUrl,
  getConfirmGrantedPermissonByGuildtUrl,

  getRevokeGrantedPermissionWalletUrl,
  getRevokeGrantedPermissonGuildUrl,

  getDeleteGrantedPermissionWalletUrl,
  getDeleteGrantedPermissonGuildUrl,

  getGrantedPermissionWalletUrl,
  getGrantedPermissonGuildUrl,


  getRecievedPermissionGuildUrl,
  getRecievedPermissionWalletUrl,

  getConfirmRecievedermissonByWalletUrl,
  getConfirmRecievedPermissonByGuildtUrl,

  getRevokeRecievedPermissionWalletUrl,
  getRevokeRecievedPermissonGuildUrl,

  getDeleteRecievedPermissionWalletUrl,
  getDeleteRecievedPermissonGuildUrl,


} from 'URLs';
export function getPermission(params) {
  return api.get(getPermissionUrl(), { params }).then((res) => res.data);
}

export function confirmPermissionWallet(item, walletCode) {
  return api.put(getConfirmGrantedPermissonByWalletUrl(item, walletCode)).then((res) => res.data);
}
export function confirmPermissionGuild(item, guildCode) {
  return api.put(getConfirmGrantedPermissonByGuildtUrl(item, guildCode)).then((res) => res.data);
}

export function revokePermissionWallet(item, walletCode) {
  return api.put(getRevokeGrantedPermissionWalletUrl(item, walletCode)).then((res) => res.data);
}

export function revokePermissionGuild(item, guildCode) {
  return api.put(getRevokeGrantedPermissonGuildUrl(item, guildCode)).then((res) => res.data);
}

export function deletePermissionWallet(item, walletCode) {
  return api.delete(getDeleteGrantedPermissionWalletUrl(item, walletCode)).then((res) => res.data);
}
export function deletePermissionGuild(item, guildCode) {
  return api.delete(getDeleteGrantedPermissonGuildUrl(item, guildCode)).then((res) => res.data);
}

export function businessGetPermissionWallet(params, walletCode) {
  return api.get(getGrantedPermissionWalletUrl(walletCode), { params }).then((res) => res.data);
}

export function businessGetPermissionGuild(params, guildCode) {
  return api.get(getGrantedPermissonGuildUrl(guildCode), { params }).then((res) => res.data);
}

export function businessGrantPermissionWallet(params, walletCode) {
  return api.post(getGrantedPermissionWalletUrl(walletCode), params);
}

export function businessGrantPermissionGuild(params, guildCode) {
  return api.post(getGrantedPermissonGuildUrl(guildCode), params);
}


//===========  دریافت شده ================

/**
 * مجوزهای مالی دریافت شده - لیست حساب دیجیتال
 */
export function getRecievedPermissionWallet(params, walletCode) {
  return api.get(getRecievedPermissionWalletUrl(walletCode), { params }).then((res) => res.data);
}

/**
 * مجوزهای مالی دریافت شده - لیست حساب های تفصیلی
 */
export function getRecievedPermissionGuild(params, guildCode) {
  return api.get(getRecievedPermissionGuildUrl(guildCode), { params }).then((res) => res.data);
}

/**
 * مجوزهای دریافت شده - تایید مجوز دیجیتال
 */
export function confirmRecievedPermissionWallet(item, walletCode) {
  return api.put(getConfirmRecievedermissonByWalletUrl(item, walletCode)).then((res) => res.data);
}
/**
 * مجوزهای دریافت شده - تایید مجوز تفصیلی
 */
export function confirmRecievedPermissionGuild(item, guildCode) {
  return api.put(getConfirmRecievedPermissonByGuildtUrl(item, guildCode)).then((res) => res.data);
}

/**
 * مجوزهای دریافت شده - لغو مجوز دیجیتال
 */
export function revokeRecievedPermissionWallet(item, walletCode) {
  return api.put(getRevokeRecievedPermissionWalletUrl(item, walletCode)).then((res) => res.data);
}

/**
 * مجوزهای دریافت شده - لغو مجوز تفصیلی
 */
export function revokeRecievedPermissionGuild(item, guildCode) {
  return api.put(getRevokeRecievedPermissonGuildUrl(item, guildCode)).then((res) => res.data);
}

/**
 * مجوزهای دریافت شده - حذف مجوز دیجیتال
 */
export function deleteRecievedPermissionWallet(item, walletCode) {
  return api.delete(getDeleteRecievedPermissionWalletUrl(item, walletCode)).then((res) => res.data);
}

/**
 * مجوزهای دریافت شده - حذف مجوز تفصیلی
 */
export function deleteRecievedPermissionGuild(item, guildCode) {
  return api.delete(getDeleteRecievedPermissonGuildUrl(item, guildCode)).then((res) => res.data);
}


//===========================



export default {
  getPermission,

  businessGetPermissionWallet,
  businessGetPermissionGuild,

  confirmPermissionWallet,
  confirmPermissionGuild,

  revokePermissionWallet,
  revokePermissionGuild,

  deletePermissionWallet,
  deletePermissionGuild,

  businessGrantPermissionWallet,
  businessGrantPermissionGuild,

  //==================
  getRecievedPermissionWallet,
  getRecievedPermissionGuild,

  confirmRecievedPermissionWallet,
  confirmRecievedPermissionGuild,


  revokeRecievedPermissionWallet,
  revokeRecievedPermissionGuild,


  deleteRecievedPermissionWallet,
  deleteRecievedPermissionGuild,
  //==============================
};
